import type { ActionContext } from 'vuex'

import type { ActionClass, AnalyticsState, IdData, PeriodsData } from '../../../models'

// @ts-strict-ignore
import { StatsReportsIdsEnum } from '@empathybroker/tsclient-stats/dist/enums/stats-reports-ids.enum'

import { LoadDistDataAction } from '../actions/load-dist-data.action'
import { ANALYTICS_CONSTS } from '../analytics.consts'

export class LoadPivotDataAction implements ActionClass {
  static async execute(
    this: void,
    { dispatch, commit, state }: ActionContext<AnalyticsState, any>,
    payload: { pivotId: string; selectedId?: string },
  ): Promise<void> {
    let pivotData: PeriodsData
    if (!payload.selectedId) {
      pivotData = state.data.overall.pivots[payload.pivotId]
    } else {
      const selectedIdData: IdData = state.data.ids[payload.selectedId]
      if (selectedIdData) {
        pivotData = selectedIdData.pivots[payload.pivotId]
      }
    }
    const reportId = payload.selectedId
      ? StatsReportsIdsEnum.PIVOTED_QUERIES
      : StatsReportsIdsEnum.PIVOTED_SEARCH
    const reportParams: any = {
      pivots: [payload.pivotId],
    }
    if (payload.selectedId) {
      reportParams.query = payload.selectedId
    }
    try {
      const newPivotData: Partial<PeriodsData> = {}
      if (!pivotData?.currentPeriod) {
        newPivotData.currentPeriod = await dispatch(ANALYTICS_CONSTS.actions.fetchStatsReport, {
          id: reportId,
          params: reportParams,
        })
      }
      const periodToCompare = LoadDistDataAction.getPeriodToCompare()
      if (!!periodToCompare && !pivotData?.[periodToCompare]) {
        const periodToCompareDates = LoadDistDataAction.getPeriodToCompareDates(periodToCompare)
        newPivotData[periodToCompare] = await dispatch(ANALYTICS_CONSTS.actions.fetchStatsReport, {
          id: reportId,
          params: {
            ...reportParams,
            startDate: periodToCompareDates[0],
            endDate: periodToCompareDates[1],
          },
        })
      }
      if (Object.keys(newPivotData).length) {
        commit(ANALYTICS_CONSTS.mutations.setPivotData, {
          data: newPivotData,
          pivotId: payload.pivotId,
          selectedId: payload.selectedId,
        })
      }
    } catch (error) {
      throw error
    }
  }
}
